<template>
  <div class="air-monitor-base-container">
    <MCard :title="$t('预案管理')" title-align="center">
      <MForm v-bind="formConfig" :model="formModel" />

      <MTable
        i18n-path="query"
        :loading="loading"
        :tableData="hisData"
        :tableColumn="tableColumn"
        :oprateMenu="oprateMenu"
        :pagiOption="pagiOption"
        height="calc(100% - 80px)"
        v-on:search="search"
      ></MTable>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table';
import MForm from '@/components/form/index.vue';
import MCard from '@/components/mCard/index.vue';
import { convertArrayToObject } from '@/utils/utils';
import { dictByCodeServer } from '@/api/dict';

import { merge } from 'lodash';
import { emergencyPlanPageServer } from '@/api/air-monitor/alarm-center';

export default {
  name: 'historyWarn',
  components: { MTable, MCard, MForm },
  props: {
    sn: String,
    deviceType: String
  },
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;
      return merge(
        {
          limit: pagiOption.limit,
          offset: pagiOption.offset
        },
        formModel
      );
    }
  },
  data() {
    return {
      hisData: [],
      loading: true,

      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100, 200],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '预案名称', prop: 'name' },
        { label: '预案内容', prop: 'content' },
        { label: '事件类型', prop: 'showEventType' },
        { label: '文件', prop: 'filePath' }
      ],
      oprateMenu: {
        label: '操作',
        list: [
          {
            text: '预览文件',
            access: row => {
              return (row.filePath || '').includes('https');
            },
            event: (_index, data) => {
              this.previewFileHandle(data);
            }
          }
        ]
      },
      formConfig: {
        i18nPath: 'query',
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              type: 'input',
              prop: 'name',
              span: 4,
              label: '预案名称'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.search();
                  setLoading(false);
                }
              }
            ]
          }
        },
        model: {
          name: ''
        },
        dataSource: {},
        rules: {}
      },
      formModel: {
        name: ''
      }
    };
  },
  mounted() {
    this.loadEventDictHandle();
  },
  methods: {
    loadEventDictHandle() {
      let eventOptions = [];
      dictByCodeServer('rf122_event_type').then(res => {
        res.data.forEach(item => {
          eventOptions.push({
            value: item.value,
            label: item.label
          });
        });
        // this.formConfig.dataSource.eventList = eventOptions;
        this.eventDict = convertArrayToObject(res.data);
        this.search();
      });
    },

    langChangeHandler() {
      this.search();
    },
    search() {
      this.loading = true;

      emergencyPlanPageServer(this.comParams)
        .then(res => {
          res.data.list.forEach(item => {
            item.showEventType = this.eventDict[item.eventType];
          });

          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    previewFileHandle(row) {
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = row.filePath;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
      }, 200);
    }
  },
  watch: {
    flag() {
      this.formModel.name = '';
    }
  }
};
</script>

<style lang="scss"></style>
